import { CanActivateViaAuthGuard } from './../bz-authentication/bz-can-activate-auth';
import { SecurityComponent } from './security.component';
import { Routes } from '@angular/router';
import { SecurityLdapComponent } from './security-ldap/security-ldap.component';
import {menus} from '../core/models/constants';
export const RoutesSecurity: Routes = [
    {
        path: menus.Security.path,
        component: SecurityComponent,
        data: { title : menus.Security.title },
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: menus.Ldap.path,
        component: SecurityLdapComponent,
        data: { title : menus.Ldap.title },
        canActivate: [CanActivateViaAuthGuard]
    }
];
